import { buildApiUrl } from "../../services/apiConfig";

class SegmentationService {
  constructor() {
    this.API_HOST = process.env.REACT_APP_NVIDIA_GPU_API_URL;
  }
  
  async getAnalyses() {
    const response = await fetch(buildApiUrl('CLUSTER', '/api/analyses'));
    if (!response.ok) {
      throw new Error(`Failed to fetch analyses: ${response.status}`);
    }
    return response.json();
  }
  
  async loadAnalysis(saveDir) {
    const response = await fetch(buildApiUrl('CLUSTER',`/api/analyses/${encodeURIComponent(saveDir)}/load`));
    if (!response.ok) {
      throw new Error(`Failed to load analysis: ${response.status}`);
    }
    return response.json();
  }
  
  async deleteAnalysis(saveDir) {
    const response = await fetch(buildApiUrl('CLUSTER',`/api/analyses/${encodeURIComponent(saveDir)}`), { 
      method: 'DELETE' 
    });
    if (!response.ok) {
      throw new Error(`Failed to delete analysis: ${response.status}`);
    }
    return response.json();
  }
  
  async uploadFile(file, params = {}) {
    const formData = new FormData();
    formData.append('file', file);
    
    if (params.openai_key) {
      formData.append('params_json', JSON.stringify({ openai_key: params.openai_key }));
    }

    const response = await fetch(buildApiUrl('CLUSTER','/cluster/upload'), {
      method: 'POST',
      body: formData,
    });

    if (!response.ok) {
      throw new Error(`Upload failed with status: ${response.status}`);
    }

    return response.json();
  }
  
  async getSummaryStatistics(saveDir) {
    const response = await fetch(buildApiUrl('CLUSTER',`/api/download/summary_statistics.json?save_dir=${encodeURIComponent(saveDir)}`));
    if (!response.ok) {
      throw new Error(`Failed to fetch summary statistics: ${response.status}`);
    }
    return response.json();
  }
  
  async getClusterThemes(saveDir) {
    const response = await fetch(buildApiUrl('CLUSTER',`/api/download/cluster_themes.json?save_dir=${encodeURIComponent(saveDir)}`));
    if (!response.ok) {
      throw new Error(`Failed to fetch cluster themes: ${response.status}`);
    }
    return response.json();
  }
  
  async getAnomalyExplanations(saveDir) {
    const response = await fetch(buildApiUrl('CLUSTER',`/api/download/anomaly_explanations.json?save_dir=${encodeURIComponent(saveDir)}`));
    if (!response.ok) {
      throw new Error(`Failed to fetch anomaly explanations: ${response.status}`);
    }
    return response.json();
  }
  
  async getMetadata(saveDir) {
    try {
      const response = await fetch(buildApiUrl('CLUSTER',`/api/download/meta.json?save_dir=${encodeURIComponent(saveDir)}`));
      if (!response.ok) {
        return null; 
      }
      return response.json();
    } catch (error) {
      console.warn('Metadata not available:', error);
      return null;
    }
  }
  
  getClusterVisualizationUrl(saveDir) {
    return `/api/images/clusters_interactive.html?save_dir=${encodeURIComponent(saveDir)}`;
  }
}

export default new SegmentationService();